require('./brokerCreateTransferOfDerivativesStep1.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @commons
const { AmountInput } = require('commonsComponents/amountInput');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @constants
const {
    FIRST_STEP,
    BROKER_STOCKS_CONTRACT_DROPDOWN_DERIVATIVES_TRANSFER_MODIFIER,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVE_VALID_PRODUCT_SUBTYPE,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVE_VALID_PRODUCT_TYPE,
    BROKER_FUTURES_TRASPASS_MAXIMUM_LENGTH,
    BROKER_FUTURES_TRASPASS_FRACTION_LENGTH,
    BROKER_FUTURES_TRASPASS_MAXIMUM_VALUE,
    CHECKING_ACCOUNT_TYPE
} = require('constants/index');
const { ACCOUNTS_FUTURES_TRANSFERS } = require('constants/accounts');

class BrokerCreateTransferOfDerivativesStep1 extends React.Component {
    buildDestinationAccountDropdown() {
        const { immAccounts, onChangeAccount, immBrokerCreateTransferOfDerivatives } = this.props;
        const immFirstStep = immBrokerCreateTransferOfDerivatives.getIn(['steps', FIRST_STEP]);
        const accountsMap = immAccounts.get('byId').filter(account => account.get('newProduct')=== CHECKING_ACCOUNT_TYPE && ACCOUNTS_FUTURES_TRANSFERS.includes(account.get('accountType')));
        const accountsIndexes = Object.keys(accountsMap.map(account => account.get('id')).toJS());
        const destinationAccount = immFirstStep.get('destinationAccount');
        const accountInvalid = immFirstStep.get('accountIsDirty');
        const dropdownLabel = formatText('broker-transferOfDerivativesCreateDestinationAccountLabel');
        const errorMsg = formatText('broker-transferOfDerivativesCreateInvalidSelectedAccount');
        return (
            <DropdownAccounts
                id="drd_PassStep1_Origin"
                label={dropdownLabel}
                immAccounts={accountsMap}
                accountsIndexes={accountsIndexes}
                currentAccountId={destinationAccount}
                onAccountChange={onChangeAccount}
                error={accountInvalid}
                errorMsg={errorMsg}
                showAvailableBalance={true}
            />
        );
    }

    buildOriginAccountDropdown() {
        const {
            immBrokerCreateTransferOfDerivatives,
            immBrokerWallets,
            onChangeOriginDerivative
        } = this.props;

        let result;

        if (immBrokerWallets.get('isFetchingProducts')) {
            result = <LoadingSection />;
        } else {
            const originDerivativeOptions = this.buildOriginDerivativeOptions();

            const selectedOriginDerivative = immBrokerCreateTransferOfDerivatives.getIn([
                'steps',
                FIRST_STEP,
                'selectedOriginDerivative'
            ]);

            const invalidSelectedOriginDerivative = immBrokerCreateTransferOfDerivatives.getIn([
                'steps',
                FIRST_STEP,
                'invalidSelectedOriginDerivative'
            ]);

            result = (
                <StocksContractDropdown
                    showAdditionalInfo={false}
                    modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_DERIVATIVES_TRANSFER_MODIFIER}
                    placeholder={formatText(
                        'broker-transferOfDerivativesCreateSelectOriginDerivativePlaceholder'
                    )}
                    label="broker-transferOfDerivativesCreateOriginAccountLabel"
                    onStockContractChange={onChangeOriginDerivative}
                    options={originDerivativeOptions}
                    selectedValue={selectedOriginDerivative}
                    errorState={invalidSelectedOriginDerivative}
                    errorMessage={formatText(
                        'broker-transferOfDerivativesCreateInvalidSelectedOriginDerivative'
                    )}
                />
            );
        }

        return result;
    }

    buildOriginDerivativeOptions() {
        const { immBrokerWallets } = this.props;
        const immValidBrokerFutures = immBrokerWallets.get('futuresList').filter(immFuture => {
            const productSubType = immFuture.getIn(['criterios', 'c1', 'subtipoproducto']);
            const productType = immFuture.getIn(['cnuevo', 'producto']);

            return (
                productSubType == BROKER_CREATE_TRANSFER_OF_DERIVATIVE_VALID_PRODUCT_SUBTYPE &&
                productType == BROKER_CREATE_TRANSFER_OF_DERIVATIVE_VALID_PRODUCT_TYPE
            );
        });

        const immOptions = immValidBrokerFutures.map(immFuture => ({
            value: immFuture.getIn(['cviejo', 'numerodecontrato']),
            walletAccountType: immFuture.get('descripcion', '')
                ? immFuture.get('descripcion', '').trim()
                : '',
            walletNumber: immFuture.getIn(['ibanComplex', 'codbban']),
            walletBalance: {
                amount: immFuture.getIn(['saldoActual', 'importe']),
                currency: immFuture.getIn(['saldoActual', 'divisa'])
            }
        }));

        return immOptions.toJS();
    }

    render() {
        const {
            immBrokerCreateTransferOfDerivatives,
            actions,
            cancelButton,
            nextButton,
            onChangeAmount
        } = this.props;

        const amount = immBrokerCreateTransferOfDerivatives.getIn(['steps', FIRST_STEP, 'amount']);

        const invalidAmount = immBrokerCreateTransferOfDerivatives.getIn([
            'steps',
            FIRST_STEP,
            'invalidAmount'
        ]);

        const destinationContent = this.buildDestinationAccountDropdown();

        const maxFractionLength = BROKER_FUTURES_TRASPASS_FRACTION_LENGTH;
        const maxIntegerLength = BROKER_FUTURES_TRASPASS_MAXIMUM_LENGTH;
        const maxValue = BROKER_FUTURES_TRASPASS_MAXIMUM_VALUE;

        return (
            <WizardStep
                actions={actions}
                cancelButton={cancelButton}
                nextButton={nextButton}
                position="first"
            >
                <h4 className="broker-create-transfer-of-derivative-step1__title">
                    <FormattedText value="broker-transferOfDerivativesCreateTitle" />
                </h4>

                <div className="broker-create-transfer-of-derivative-step1__field">
                    {this.buildOriginAccountDropdown()}
                </div>

                <div className="broker-create-transfer-of-derivative-step1__field">
                    {destinationContent}
                </div>

                <div className="broker-create-transfer-of-derivative-step1__field">
                    <div className="broker-create-transfer-of-derivative-step1__field">
                        <AmountInput
                            label={formatText('broker-transferOfDerivativesCreateAmountLabel')}
                            amount={amount}
                            callback={onChangeAmount}
                            error={invalidAmount}
                            errorMsg={formatText('broker-transferOfDerivativesCreateInvalidAmount')}
                            showBlurZero
                            hideFocusZero
                            disablePaste
                            maxFractionLength={maxFractionLength}
                            maxIntegerLength={maxIntegerLength}
                            max={maxValue}
                            language={getLanguage()}
                        />
                    </div>
                </div>
            </WizardStep>
        );
    }
}

BrokerCreateTransferOfDerivativesStep1.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immBrokerCreateTransferOfDerivatives: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeAccount: PropTypes.func.isRequired,
    onChangeOriginDerivative: PropTypes.func.isRequired,
    onChangeAmount: PropTypes.func.isRequired,
    onChangeConcept: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool
};

BrokerCreateTransferOfDerivativesStep1.defaultProps = {
    cancelButton: true,
    nextButton: true
};

module.exports = BrokerCreateTransferOfDerivativesStep1;